// Arabisch (ar), remindersApp: zelfde vorm als remindersApp.nl.ts. Duur kort met "د" (دقيقة) en
// "س" (ساعة), zoals gebruikelijk in Arabische apps.
export const appRemindersAr = {
    section: 'التذكيرات',
    sectionHint: 'تنبيه إضافي على الجهاز اللوحي: تنادي الشاشة طفلك باسمه، مع صورة كبيرة. مع قائمة للتأشير بما يجب أخذه.',
    allDayHint: 'التذكيرات تعمل مع المواعيد التي لها وقت.',
    add: 'تذكير',
    addTitle: 'تذكير جديد',
    editTitle: 'تعديل التذكير',
    edit: 'تعديل',
    remove: 'إزالة',
    removed: 'أُزيل التذكير',
    confirmAdd: 'إضافة التذكير',
    confirmSave: 'تحديث التذكير',
    closeForm: 'إغلاق النموذج دون هذا التذكير',
    max: '5 تذكيرات على الأكثر لكل موعد.',
    when: 'متى',
    customWhen: 'وقت آخر',
    customLabel: 'دقائق قبل الموعد',
    customHint: 'من 1 إلى 1440 دقيقة (يوم كامل).',
    offsetInvalid: 'اختر من 1 إلى 1440 دقيقة.',
    text: 'النص',
    textPlaceholder: 'استعد للتدريب',
    textRequired: 'اكتب نصًا قصيرًا.',
    textTooLong: '60 حرفًا على الأكثر.',
    suggestions: 'اقتراحات',
    picto: 'الرمز',
    forWho: 'لمن',
    everyone: 'كل من في الموعد',
    everyoneKids: 'كل الأطفال',
    whoRequired: 'اختر لمن هذا التذكير.',
    prunedChanged: '{names} لم يعد مشاركًا؛ عُدّل التذكير «{title}».',
    prunedChangedMany: '{names} لم يعودوا مشاركين؛ عُدّل التذكير «{title}».',
    prunedRemoved: '{names} لم يعد مشاركًا؛ أُزيل التذكير «{title}».',
    prunedRemovedMany: '{names} لم يعودوا مشاركين؛ أُزيل التذكير «{title}».',
    prunedThisHint: 'إذا اخترت عند الحفظ «هذه المرة فقط»، تبقى التذكيرات في المرات الأخرى كما هي.',
    allDayDrop: 'في موعد طوال اليوم لا ينادي الجهاز اللوحي: ستُحذف هذه التذكيرات عند الحفظ.',
    and: 'و',
    speak: 'القراءة بصوت عالٍ',
    speakHint: 'يقول الجهاز اللوحي الاسم والنص بصوت عالٍ.',
    sound: 'الصوت',
    soundHint: 'جرس خفيف (ليس في ساعات الهدوء).',
    preview: 'هكذا ينادي الجهاز اللوحي',
    previewOk: 'حسنًا',
    previewContext: '{title} الساعة {time}',
    previewNoTitle: 'موعد',
    minutes: '{count} د',
    hours: '{count} س',
    hoursMinutes: '{hours} س {minutes} د',
    before: 'قبل {when}',
    chip: 'قبل {when} · {title}',
    chipLabel: 'تذكير قبل {when}: {title}',
    skipOnce: 'ليس هذه المرة فقط',
    skipOnceLabel: 'التذكير «{title}»: ليس هذه المرة فقط',
    skipOnceDone: 'لن ينادي الجهاز اللوحي هذه المرة: {title}',
    skippedChip: 'ليس هذه المرة',
    unskip: 'نادِ رغم ذلك',
    unskipLabel: 'التذكير «{title}»: نادِ هذه المرة رغم ذلك',
    unskipDone: 'سينادي الجهاز اللوحي هذه المرة من جديد: {title}',
    suggestTraining: 'استعد للتدريب',
    suggestSwim: 'جهّز حقيبة السباحة',
    suggestBag: 'جهّز الحقيبة',
    suggestShoes: 'البس الحذاء والجاكيت',
    suggestGeneric: 'استعد لـ {title}',
    suggestGenericEmpty: 'استعد',
    taskTime: 'الوقت',
    taskTimeHint: 'يمكن تركه فارغًا.',
    taskAnnounce: 'الإعلان على اللوحة',
    taskAnnounceHint: 'في ذلك الوقت يرنّ الجهاز اللوحي ويقول من عليه أن يفعل ماذا. صامت في ساعات الهدوء وفي الليل.',
};
//# sourceMappingURL=remindersApp.ar.js.map